import {
  ReportDashboardComponentKind,
  ReportDashboardComponentViewMode,
  VisualizationType,
  type ReportDashboardComponentViewData,
} from '@core/reports-types';

export type GetComponentVisualizationTypeInput = Pick<
  ReportDashboardComponentViewData,
  'viewMode' | 'kind' | 'primaryGroup' | 'secondaryGroup' | 'metric'
>;

export const getComponentVisualizationType = (
  component: GetComponentVisualizationTypeInput,
): VisualizationType => {
  switch (component.viewMode) {
    case ReportDashboardComponentViewMode.Chart: {
      return VisualizationType.Chart;
    }
    case ReportDashboardComponentViewMode.Summary: {
      return VisualizationType.Summary;
    }
    case ReportDashboardComponentViewMode.Table: {
      if (component.kind === ReportDashboardComponentKind.Breakdown && component.secondaryGroup) {
        return VisualizationType.PivotTable;
      }
      if (component.kind === ReportDashboardComponentKind.Trend && component.primaryGroup) {
        return VisualizationType.PivotTable;
      }
      // TODO the solution could and should be more generic, maybe backend driven. CU-86c4x5z1z
      if (
        component.kind === ReportDashboardComponentKind.SingleMetric &&
        component.primaryGroup &&
        component.secondaryGroup
      ) {
        return VisualizationType.PivotTable;
      }
      return VisualizationType.Table;
    }
    default: {
      throw new Error('Unknown view mode:', component.viewMode);
    }
  }
};
